/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import PostPreview from "@components/PostPreview";

import styles from "./lastPosts.module.scss";

export interface ILastPosts {
	posts: Array<{
		id: number | string;
		title: string;
		date: string;
		slug: string;
		excerpt: string;
		categories?: any;
		featuredImage: {
			node: {
				srcSet: string;
				altText: string;
				sourceUrl: string;
			};
		};
	}>;
	hideTitle?: boolean;
}

const LastPosts = ({ posts, hideTitle }: ILastPosts): JSX.Element => {
	return (
		<section className={styles.lastPosts}>
			<div className={styles.lastPostsTitleContainer}>
				{!hideTitle && (
					<h2 className={styles.lastPostsTitle}>
						Últimas Postagens
						<span className={styles.scribble}></span>
					</h2>
				)}
			</div>

			<ul>
				{posts.map((post) => {
					return (
						<li key={post.id}>
							<PostPreview
								title={post.title}
								date={post.date}
								slug={post.slug}
								excerpt={post.excerpt}
								category={post?.categories?.nodes[0]?.name}
								srcSet={post.featuredImage?.node?.srcSet}
								altText={post.featuredImage?.node?.altText}
								coverImage={post.featuredImage?.node?.sourceUrl}
							/>
						</li>
					);
				})}
			</ul>
		</section>
	);
};

export default LastPosts;
